import React from "react";
import "./QualidadeBannerMobile.scss";
import { desktopImages, mobileImages } from "../../../../images";

const QualidadeBannerMobile = () => {
  return (
    <div className="qualidade-banner-mobile">
      <div className="container">
        <div className="mobile-banner-content">
          <h2 className="mobile-banner-title">
            A EXCELÊNCIA<br />
            ESTÁ NOS DETALHES
          </h2>

          <div className="mobile-banner-items">
            <div className="mobile-banner-item">
              <div className="mobile-item-icon">
                <img
                  src={desktopImages.IconMateriasPrimas}
                  alt="Matérias-primas premium"
                />
              </div>
              <h3 className="mobile-item-title">MATÉRIAS-PRIMAS<br />PREMIUM</h3>
              <div className="mobile-item-content">
                <p className="mobile-item-subtitle">Do mundo para você.</p>
                <p className="mobile-item-description">
                  Selecionamos matérias-primas de origem global, com pureza e eficácia comprovadas por estudos clínicos. O que há de melhor na ciência mundial chega até você, com a qualidade que faz a diferença na sua saúde e bem-estar.
                </p>
              </div>
              <div className="mobile-item-divider"></div>
            </div>

            <div className="mobile-banner-item">
              <div className="mobile-item-icon">
                <img
                  src={desktopImages.IconControleQualidade}
                  alt="Controle de qualidade"
                />
              </div>
              <h3 className="mobile-item-title">CONTROLE DE<br />QUALIDADE</h3>
              <div className="mobile-item-content">
                <p className="mobile-item-subtitle">Ciência que cuida.</p>
                <p className="mobile-item-description">
                  Em nossos laboratórios, cada fórmula passa por análises rigorosas. Equipamentos de alta precisão e processos detalhados garantem segurança, confiança e consistência em cada resultado.
                </p>
              </div>
              <div className="mobile-item-divider"></div>
            </div>

            <div className="mobile-banner-item">
              <div className="mobile-item-icon">
                <img
                  src={desktopImages.IconPesquisaInovacao}
                  alt="Pesquisa e inovação"
                />
              </div>
              <h3 className="mobile-item-title">Pesquisa e inovação</h3>
              <div className="mobile-item-content">
                <p className="mobile-item-subtitle">Inovar para <br /> transformar.</p>
                <p className="mobile-item-description pesquisa-e-inovacao">
                  A inovação é parte da nossa essência. Já lançamos mais de 170 produtos e seguimos investindo em pesquisa e tecnologia, porque acreditamos na inovação como forma de transformar vidas.
                </p>
              </div>
              <div className="mobile-item-divider"></div>
            </div>

            <div className="mobile-banner-item">
              <div className="mobile-item-icon">
                <img
                  src={desktopImages.IconCertificados}
                  alt="Nossos certificados"
                />
              </div>
              <h3 className="mobile-item-title">Nossos Certificados</h3>
              <div className="mobile-item-content mb-0">
                <img className="certificados-mobile" src={mobileImages.Certificados} alt="Certificados" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QualidadeBannerMobile;